import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ChevronRight, Users } from 'lucide-react'

import { listTenants } from '../lib/api'

export default function Admin() {
  const { data, isLoading, error } = useQuery({ queryKey: ['tenants'], queryFn: listTenants })

  return (
    <div className="h-full flex flex-col">
      <header className="border-b border-line px-6 py-5">
        <div className="h-eyebrow">Admin</div>
        <h1 className="h-section">Tenants</h1>
        <p className="text-sm text-ink-500 mt-1">
          Provision users + mailboxes for the tenants you administer.
        </p>
      </header>

      {isLoading && <div className="p-6 text-ink-500">Loading…</div>}
      {error && <div className="p-6 text-red-700">{error instanceof Error ? error.message : String(error)}</div>}

      <ul className="p-4 space-y-2 overflow-auto">
        {data?.tenants.map(t => (
          <li key={t.slug}>
            <Link to={`/admin/tenants/${t.slug}`} className="card p-4 flex items-center gap-4 hover:shadow-lift transition-shadow">
              <div className="w-10 h-10 rounded-soft grid place-items-center text-raised font-semibold text-lg"
                   style={{ background: t.brand_color || '#1a1f2e' }}>
                {t.name.slice(0, 1).toUpperCase()}
              </div>
              <div className="flex-1">
                <div className="font-semibold text-ink-900">{t.name}</div>
                <div className="text-sm text-ink-500 font-mono">
                  <span>{t.slug}.plustag.email</span>
                  <span className="mx-2 text-ink-300">/</span>
                  <span>{t.slug}.preprod.plustag.email</span>
                </div>
              </div>
              <Users size={16} className="text-ink-500" />
              <ChevronRight size={18} className="text-ink-500" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
